import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { renderRoutes } from "react-router-config";
import { useUsersPointsBalance } from "../../hooks/useUsersPointsBalance";
const Layout = ({ route }) => {
    useUsersPointsBalance();
    return _jsx(_Fragment, { children: renderRoutes(route === null || route === void 0 ? void 0 : route.routes) });
};
export default Layout;
